import { useState, useEffect, useRef } from "react";
import { Box, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { styled } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import DataFilterMap from "../geofilter4";
import { useChat } from "../../index";
import TimeSeries from "../time-series";
import Histogram from "../histogram-revised";
import BarChart from "../bar-chart";
import ToyotaLogoLoader from "../toyota-loader";
import SpeechToText from "../speech-text";

export function AddPathIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.6667 5H8.33333C6.49238 5 5 6.49238 5 8.33333V31.6667C5 33.5076 6.49238 35 8.33333 35H31.6667C33.5076 35 35 33.5076 35 31.6667V8.33333C35 6.49238 33.5076 5 31.6667 5Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 13.332V26.6654" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.3334 20H26.6667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export function SendIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33 3L16.5 19.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M33 3L22.5 33L16.5 19.5L3 13.5L33 3Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export function CanvaToyotaLogo() {
    return (
        <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="25.3994" cy="25.2836" rx="25.1006" ry="25.2836" fill="#EB0A1E" />
            <path d="M25 11C16.5034 11 10 17.0046 10 25C10 32.732 16.3375 39 25 39C33.6625 39 40 32.732 40 25C40 17.0046 33.4966 11 25 11ZM34.353 17.0046C34.6656 18.7307 33.1984 20.8879 28.4786 21.5933C28.1645 17.198 27.213 13.4842 25.6366 12.6979C27.7591 12.7801 29.7709 13.2716 31.525 14.1433C33.1656 14.9913 34.1842 16.0737 34.353 17.0046ZM27.3616 24.9319C27.3616 30.5016 26.1409 32.8098 25 32.8098C23.8591 32.8098 22.6384 30.5009 22.6384 24.9319V24.8677C23.4238 24.96 24.2117 25.0069 25 25.0084C25.7882 25.0091 26.5761 24.9643 27.3616 24.8741V24.9383V24.9319ZM24.9991 21.8278C24.2609 21.8293 23.5229 21.7997 22.7861 21.7391C23.1447 18.0967 24.0967 15.9799 24.9995 15.9799C25.9023 15.9799 26.8544 18.0973 27.213 21.7385C26.5323 21.8027 25.7955 21.8278 24.9991 21.8278ZM15.6456 17.0033C15.8134 16.0782 16.8231 15.0016 18.4488 14.1549C20.2089 13.2748 22.2306 12.7782 24.3634 12.6966C22.7866 13.4829 21.8355 17.1967 21.5214 21.592C16.8011 20.8867 15.3339 18.7295 15.6456 17.0033ZM12.2125 24.4957C12.1998 22.2768 12.7589 20.1229 13.7913 18.4134C13.9211 21.5393 17.0069 23.8706 21.4061 24.6897L21.4056 24.9338C21.4056 32.4757 22.8119 36.4747 24.3803 37.3002C17.6641 36.9694 12.2125 31.3001 12.2125 24.497V24.4957ZM25.593 37.3002C27.168 36.4394 28.5953 32.1481 28.5953 24.9325L28.5948 24.6884C32.9945 23.87 36.0798 21.5387 36.2097 18.4121C37.242 20.1216 37.8011 22.2755 37.7884 24.4944C37.7884 31.3072 32.3219 36.9828 25.593 37.2989V37.3002Z" fill="white" />
        </svg>
    )
}

export function UserAvatar() {
    return (
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M45 22.5C45 34.9267 34.9267 45 22.5 45C10.0733 45 0 34.9267 0 22.5C0 10.0733 10.0733 0 22.5 0C34.9267 0 45 10.0733 45 22.5ZM29.25 15.75C29.25 17.5402 28.5388 19.2571 27.273 20.523C26.0071 21.7888 24.2902 22.5 22.5 22.5C20.7098 22.5 18.9929 21.7888 17.727 20.523C16.4612 19.2571 15.75 17.5402 15.75 15.75C15.75 13.9598 16.4612 12.2429 17.727 10.977C18.9929 9.71116 20.7098 9 22.5 9C24.2902 9 26.0071 9.71116 27.273 10.977C28.5388 12.2429 29.25 13.9598 29.25 15.75ZM22.5 41.625C26.3616 41.6312 30.1338 40.4627 33.3157 38.2747C34.6747 37.341 35.2552 35.5635 34.4632 34.1168C32.8275 31.1175 29.4525 29.25 22.5 29.25C15.5475 29.25 12.1725 31.1175 10.5345 34.1168C9.74475 35.5635 10.3252 37.341 11.6842 38.2747C14.8662 40.4627 18.6384 41.6312 22.5 41.625Z" fill="black" />
        </svg>

    )
}

const MessageContainer = styled(Box)(({ isUser }) => ({
    display: "flex",
    justifyContent: isUser ? "flex-end" : "flex-start",
    marginBottom: "8px",
}));

const MessageBubble = styled(Box)(() => ({
    maxWidth: "70%",
    padding: "12px",
    borderRadius: "20px",
    wordWrap: "break-word",
}));

const ChatInterface = ({ setConvStarted }: any) => {
    const { selectedPrevMessage } = useChat();
    const [messages, setMessages] = useState([{ canva: true, text: "Hi User, How can I help you?" }]);
    const [inputValue, setInputValue] = useState("");
    const [dataPath, setDataPath] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [dataStreaming, setDataStreaming] = useState(false);
    const [currentMessage, setCurrentMessage] = useState("");
    const signal = ["Speed"]
    const messagesEndRef = useRef(null);
    const range = [
        "2023-09-13T17:00:00",
        "2023-09-14T17:00:00"
    ];
    const socketRef = useRef(null);
    const [previousConv] = useState(localStorage.getItem("conversation") ? JSON.parse(localStorage.getItem("conversation")) : null)
    let conversation = [];
    useEffect(() => {
        if (selectedPrevMessage?.length > 0) {
            setMessages(selectedPrevMessage)
        }
    }, [selectedPrevMessage])
    //const webSocketUrl = "wss://echo.websocket.org/"
    useEffect(() => {
        // Create WebSocket connection
        //wss://echo.websocket.org/
        socketRef.current = new WebSocket("ws://127.0.0.1:8080/ws");

        // Connection opened
        socketRef.current.onopen = () => {
            console.log("Connected to WebSocket server");
        };
        let responseValue = [];
        // Listen for messages
        socketRef.current.onmessage = (event) => {
            const newMessage = JSON.parse(event.data);
            const mapData = newMessage?.mapdata ? getLatLongPositionData(newMessage?.mapdata) : null;
            const timeSeriesData = newMessage?.timeSeries ? getTimeSeriesData(newMessage?.timeSeries) : null;
            const histgramData = newMessage?.histogram ? newMessage?.histogram : null;
            const barChartData = newMessage?.barchart ? getBarChartData(newMessage?.barchart) : null;
            if (newMessage?.status === "done") {
                if (mapData) {
                    newMessage["mapdata"] = mapData;
                }
                if (timeSeriesData) {
                    newMessage["timeseries"] = timeSeriesData;
                }
                if (histgramData) {
                    newMessage["histgramdata"] = histgramData;
                }
                if (barChartData) {
                    newMessage["barChartData"] = barChartData;
                }
                console.log("current", currentMessage)
                setMessages((prevMessages) => [...prevMessages, { text: currentMessage, canva: true, mapdata: newMessage?.mapdata, timeseries: newMessage?.timeseries, histogramdata: newMessage?.histgramdata, barChartData: newMessage?.barChartData }]);
                responseValue = [];
                setDataStreaming(false)
            } else {
                responseValue.push(newMessage?.content)
                setDataStreaming(false)
                setCurrentMessage((prev) => prev + newMessage?.content)
            }
        };

        socketRef.current.onclose = function (event) {
            console.log("WebSocket closed:", event);
        };

        // Cleanup on unmount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    console.log("cur", currentMessage)
    const getBarChartData = (data) => {
        if (data?.length > 0) {
            let xAxisData = [];
            let yAxisData = [];
            data?.length > 0 && data?.forEach((item) => {
                xAxisData.push(item?.vehicleName);
                yAxisData.push(item?.vin_count);
            })

            return { xAxisData, yAxisData }
        } else {
            return null
        }

    }

    function unpack(rows, key) {
        return rows?.map(function (row) { return row[key]; });
    }

    const getTimeSeriesData = (data) => {
        const updatedData = generateTimeSeriesData(data)
        let list = [];
        signal?.length > 0 && signal?.forEach((element) => {
            const listItem = []
            updatedData && Object.entries(updatedData)?.forEach((item) => {
                listItem.push(generateLineData(element, item))
            })
            list.push(listItem);
        })

        return list
    }


    const generateTimeSeriesData = (data) => {
        try {
            let dataValue = JSON.stringify(data);
            if (dataValue?.indexOf("NaN") >= 0) {
                dataValue = dataValue.replaceAll("NaN", "0");
                dataValue = JSON.parse(JSON.parse(dataValue))
                return dataValue;
            } else {
                return data
            }
        } catch (e) {
            console.log("errorr")
            return data;
        }
    }


    const getLatLongPositionData = (list) => {
        let position = [];
        list?.forEach((item, index) => {
            const data = {
                id: index,
                position: [item?.latitude, item?.longitude],
                data: item?.vins
            }
            position.push(data)
        })
        return position;
    }

    const handleSendMessage = (transcript) => {
        const value = transcript?.length >= 0 ? transcript : inputValue;
        if (value.trim()) {
            setMessages([...messages, { text: value, canva: messages.length % 2 === 0 }]);

            let payloadData = { "user_id": "user1", "conversation_id": "session1", "bot": "gpt-4o", "user_content": value, "s3_path": "s3://hackathon-unnesting-data/clean_unnested_data_partitioned_2/" };
            socketRef.current.send(JSON.stringify(payloadData));
            setInputValue("");
            setDataStreaming(true)
        }
        setConvStarted(true)
    };

    const handlePathSendMessage = () => {
        if (dataPath.trim()) {
            setMessages([...messages, { text: dataPath, canva: messages.length % 2 === 0 }]);
            let payloadData = { "user_id": "venkateshGuduru", "conversation_id": "sample_session_id", "model": "sample_model", "user_content": "", "s3_path": dataPath };
            socketRef.current.send(JSON.stringify(payloadData));
            setInputValue("");
            setDataStreaming(true)
        }
        setConvStarted(true)
        setOpenModal(false)
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSendMessage();
        }
    };



    const handleClear = () => {
        setDataPath("");
        setInputValue("")
    };

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    const setSession = async () => {
        localStorage.setItem("conversation", JSON.stringify(conversation))
    }


    const generateLineData = (signalName, dataList) => {
        const lineData = {
            x: unpack(dataList[1], "gpsDateTime"),
            y: unpack(dataList[1], signalName),
            line: "#E70B0B",
            name: dataList[0]?.length > 4 ? dataList[0]?.substr(-4) : null
        }
        return lineData;
    }


    useEffect(() => {
        const handleBeforeUnload = async () => {
            if (previousConv) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                conversation = previousConv;
                conversation.push({ time: new Date(), text: messages })
            } else {
                conversation.push({ time: new Date(), text: messages })
            }
            await setSession();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Cleanup event listener
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
         
    }, [messages]);

    const heightUpdate = window.innerWidth > 1350 ? "25vh" : "40vh";


    const timeSeriesWidth = window.innerWidth > 1350 ? 800 : 425;
    const timeSeriesHeight = window.innerWidth > 1350 ? 500 : 400;

    const handleTranscriptUpdate = (newTranscript) => {
        setInputValue(newTranscript);
        handleSendMessage(newTranscript);
    };

    console.log("lenght", currentMessage?.length)

    return (
        <div >
            <Box
                sx={{
                    maxHeight: `calc(100vh - ${heightUpdate})`,
                    overflowY: "auto",
                    padding: "16px",
                    "&::-webkitScrollbar": {
                        display: "none",
                    },
                    scrollbarWidth: "none",
                }}
            >

                {messages.map((msg, index) => (
                    <MessageContainer key={index} isUser={!msg.canva}>
                        {msg.canva && (
                            <CanvaToyotaLogo />
                        )}

                        {msg?.mapdata ?
                            <DataFilterMap mapPoints={msg?.mapdata} /> :
                            msg?.timeseries ? <TimeSeries data={msg?.timeseries} range={range} width={timeSeriesWidth} height={timeSeriesHeight} title={"Speed"} />
                                : msg?.histogramdata ? <Histogram data={msg?.histogramdata?.max_speed} />
                                    : msg?.barChartData ? <BarChart xAxisData={msg?.barChartData?.xAxisData} yAxisvalue={msg?.barChartData?.yAxisData} />
                                        : <MessageBubble>
                                            {msg?.text?.indexOf("</") > 0 ?
                                                <Typography textAlign={msg.canva ? "left" : "right"} component="div" variant="body1" dangerouslySetInnerHTML={{ __html: msg.text }} />
                                                :
                                                <Typography textAlign={msg.canva ? "left" : "right"} variant="body1">{msg.text}</Typography>}
                                        </MessageBubble>}
                        {!msg.canva &&
                            <UserAvatar />
                        }
                    </MessageContainer>
                ))}
                {dataStreaming &&
                    <div style={{ display: "flex" }}><div><CanvaToyotaLogo /></div><div style={{ paddingTop: "12px", paddingLeft: "18px" }}><ToyotaLogoLoader /></div></div>
                }
                {currentMessage?.length > 0 &&
                    <div style={{ display: "flex" }}><div><CanvaToyotaLogo /></div><div style={{ paddingTop: "12px", paddingLeft: "18px" }}><Typography textAlign={"left"} variant="body1">{currentMessage}</Typography></div></div>
                }
                <div ref={messagesEndRef} /> {/* Scroll target */}
            </Box>
            <TextField
                variant="outlined"
                placeholder="Ask your question..."
                
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconButton onClick={() => setOpenModal(true)}>
                                <AddPathIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleSendMessage}>
                                <SendIcon />
                            </IconButton>
                            <IconButton onClick={handleClear}>
                                <ClearIcon />
                            </IconButton>
                            <SpeechToText setTranscriptData={handleTranscriptUpdate} />
                        </InputAdornment>
                    ),
                    sx: {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(0, 0, 0, 0.23)", // Hide default border color
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(0, 0, 0, 0.23)", // Keep it transparent on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(0, 0, 0, 0.23)", // Keep it transparent when focused
                        },
                    },
                }}
                sx={{ width: "90%" }}
            />

            <Dialog
                open={openModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography>{"Analyse Existing DataSet Using S3 Path"}</Typography>
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        onClick={() => setOpenModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        variant="outlined"
                        placeholder="Ask your question..."
                        
                        value={dataPath}
                        onChange={(e) => setDataPath(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handlePathSendMessage}>
                                        <SendIcon />
                                    </IconButton>
                                    <IconButton onClick={handleClear}>
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)", // Hide default border color
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)", // Keep it transparent on hover
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)", // Keep it transparent when focused
                                },
                            },
                        }}
                        fullWidth
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ChatInterface;
